import {ConfigObjectType, loginContainer, useApiQuery} from '@wallaby-ui/core';
import * as React from 'react';
import {connect} from 'react-redux';
import {useParams, Navigate} from 'react-router-dom';

interface OwnProps {
  config: ConfigObjectType;
  route: string;
}

type Props = OwnProps;

export const HospitalizedPatientsByHospSrcIdContainer: React.FC<Props> = (
  props
) => {
  const {config, ..._restProps} = props;
  const {hospitalizationSrcId} = useParams();
  const hospitalizationIdUrl =
    config.service.url.hospitalizationsIdFromSrcId.replace(
      '{srcId}',
      hospitalizationSrcId
    );
  const {
    data: hospitalizationId,
    isLoading,
    isError,
  } = useApiQuery<number>([hospitalizationIdUrl], null, {
    axiosConfig: {
      url: hospitalizationIdUrl,
    },
  });
  if (isLoading) {
    return <>Loading...</>;
  }
  if (isError) {
    return <>Error: invalid srcId</>;
  }
  return <Navigate to={`/hospitalizedPatients/${hospitalizationId}`} />;
};
